import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import ManageQueueStatusTable from "./ManageQueueStatusTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const ManageQueueStatus = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    queues: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/Queues")
      .then((res) => res.json())
      .then((data) =>
        setDataObj({
          queues: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <ManageQueueStatusTable
            data={dataObj.queues}
            title={"Manage Queue Status"}
          />
        </div>
      )}
    </>
  );
};
export default ManageQueueStatus;
